export default __webpack_public_path__ + "static/logo-animated-c1793233ebb97377f43032ce3a883cc1.gif";